<!-- list -->
<div class="row">
    <div class="col-12">

        <div class="card" [ngClass]="{'settingsVue': settingVue}">
            <div class="card-header">
                <div class="card-header_title">{{ 'FILES.CATEGORIES_LIST' | translate }}</div>
                <div class="tools">

                    <!-- <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()"
                        (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i> Удалить выбранное
                    </button> -->

                    <!-- <button type="button" class="btn btn-primary btn-sm" (click)="onTopLevelCreate()">
                        <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                    </button> -->

                    <button *ngIf="currentRoute == '/settings'" type="button"
                    class="btn btn-primary btn-sm btn-add" (click)="onTopLevelCreate()">
                    <svg-icon src="/assets/images/icons/add.svg" [stretch]="true"
                    [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                    <span>{{ 'ADD' | translate }}</span>
                    </button>

                    <button type="button" class="close" aria-label="Close" (click)="onClose()"></button>
                    <button *ngIf="currentRoute !='/settings'" type="button" class="close" aria-label="Close" (click)="onClose()">
                        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                    </button>
                </div>
            </div>

            <div class="card-body card-body_tree">


                <!-- Search form -->
                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
                    <div class="form-inner">
                        <!-- <i class="serch-icon"><img class="th-icon" src="/assets/images/icons/closed-page-layout/search.svg"></i> -->
                        <svg-icon class="serch-icon" src="/assets/images/icons/closed-page-layout/search.svg" [stretch]="true"
                        [svgStyle]="{'width.px':20, 'margin-left.px':20, 'height.px':20}"></svg-icon>
    
                        <input formControlName="search" class="form-control" type="text" (keydown.delete)="onClear()" placeholder="{{ 'поиск категории или подкатегории' | translate }}" aria-label="Search">
                        
                        <button class="clear" *ngIf="filteredCatgory.length > 0" (click)="onClear()"> 
                            <svg-icon src="/assets/images/icons/close.svg" [stretch]="true"
                            [svgStyle]="{'width.px':20, 'margin-left.px':20, 'height.px':20}"></svg-icon>
                        </button>  
                        
                        
                                              
                        <div [ngClass]="{'serch-res_inner': filteredCatgory.length > 0}">
                            <div class="searchRes" *ngFor="let category of filteredCatgory">
        
                                <!-- <label *ngIf="filteredCatgory.length > 0 && categoryType == 'categories'"
                                    style="margin-top: 10px;">
                                    <input type="checkbox" (click)="checkState(category)"><span
                                        style="margin-left: 10px;">{{category.name}}</span>
                                </label> -->
                                <div class="custom-control custom-checkbox" [ngClass]="{'serch-res_check': filteredCatgory.length > 0}">
                                    <input class="custom-control-input" type="checkbox" *ngIf="filteredCatgory.length > 0"
                                        id="{{ category.id }}"
                                        (click)="checkState(category)">
                                    <label class="custom-control-label" for="{{ category.id }}"><span>{{category.name}}</span></label>
                                </div>  
                                <!-- <div class="custom-control custom-checkbox" *ngIf="categoryType == 'categories'" [ngClass]="{'serch-res_check': filteredCatgory.length > 0}">
                                    <input class="custom-control-input" type="checkbox" *ngIf="filteredCatgory.length > 0 && categoryType == 'categories'"
                                        id="{{ category.id }}"
                                        (click)="checkState(category)">
                                    <label class="custom-control-label" for="{{ category.id }}"><span>{{category.name}}</span></label>
                                </div>   -->
        
                                <!-- <div class="" *ngIf="filteredCatgory.length > 0 && categoryType == 'files_categories'" style="margin-top: 10px;">
        
                                    <div class="folder-name" (click)="checkState(category)">
                                        <i Class="open-folder"></i> <span class="serh-res_text">{{category.name}}</span>
                                    </div>
        
                                </div> -->
                            </div>
                        </div>

                    </div>


                </form>

                <div class="inner-container" [ngClass]="{'file-inner': !usageSpace}">
                    <!-- Tree data -->
                    <ul id="myUl" *ngIf="filteredCatgory.length == 0">
                        <ng-container *ngTemplateOutlet="Recursion; context:{ list: items}"></ng-container>
                    </ul>
    
                    <ng-template #Recursion let-list="list">
    
                        <div class="container" dragula="REVERT" [(dragulaModel)]="item">
    
                            <li class="category-item" *ngFor="let item of list; let i = index">
    
                                <div class="name-text-info">
    
                                    <div *ngIf="categoryType == 'categories' || categoryType == 'attrs_for_roles'" class="folder-block">
    
                                        <!-- <i *ngIf="item.children.length > 0"
                                            [ngClass]="item.isOpen ? 'bi bi-caret-down-fill pointer' : 'bi bi-caret-right-fill pointer'"
                                            (click)="item.isOpen = !item.isOpen"></i> -->

                                        <i *ngIf="item.children.length > 0" class="icon-dropdown" [ngClass]="item.isOpen ? 'drop-flip_down' : 'drop-flip_up'"
                                            (click)="item.isOpen = !item.isOpen">
                                            <svg-icon  src="/assets/images/icons/closed-page-layout/arrow-down.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                        </i>
    
                                        <div class="custom-control custom-checkbox" [ngClass]="item.children.length > 0 ? 'box' : 'non-children-box non-children-box_catalog'" *ngIf="!item.editable">
                                            <input class="custom-control-input" type="checkbox" name="{{ item.id }}"
                                                id="{{ item.id }}" [checked]="item.checked"
                                                (click)="checkState(item)">
                                            <label class="custom-control-label" for="{{ item.id }}"><span>{{ item.name }}</span></label>
                                        </div>    
    
                                        <!-- <label [ngClass]="item.children.length > 0 ? 'box' : 'non-children-box'"
                                            *ngIf="!item.editable">
                                            <input class="pointer" type="checkbox" [checked]="item.checked" (click)="checkState(item)">
                                            {{ item.name }}
                                        </label> -->
                                    </div>
    
                                    <div *ngIf="categoryType == 'files_categories'" class="folder-block  d-flex">

                                        <i *ngIf="item.children.length > 0" class="icon-dropdown" [ngClass]="item.isOpen ? 'drop-flip_down' : 'drop-flip_up'"
                                            (click)="item.isOpen = !item.isOpen">
                                            <svg-icon  src="/assets/images/icons/closed-page-layout/arrow-down.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                        </i>
    
                                        <!-- <div (click)="item.isOpen = !item.isOpen">
                                            <i *ngIf="item.children.length > 0"
                                                [ngClass]="item.isOpen ? 'bi bi-caret-down-fill pointer' : 'bi bi-caret-right-fill pointer'">
                                                <i [ngClass]="item.isOpen ? 'close-folder' : 'open-folder'"></i>
                                            </i>
                                        </div> -->
    
                                        <!-- <div>
                                            <img [ngClass]="item.children.length > 0 ? 'box pointer' : 'non-children-box pointer'"
                                            (click)="checkState(item)">
                                            <span class="folder-name">{{item.name}}</span>
                                        </div> -->
                                        <div class="custom-control custom-checkbox" [ngClass]="item.children.length > 0 ? 'box' : 'non-children-box non-children-box_catalog'" *ngIf="!item.editable">
                                            <input class="custom-control-input" type="checkbox" name="{{ item.id }}"
                                                id="{{ item.id }}" [checked]="item.checked"
                                                (click)="checkState(item)">
                                            <label class="custom-control-label" for="{{ item.id }}"><span>{{ item.name }}</span></label>
                                        </div>    
    
                                        <!-- <div [ngClass]="item.children.length > 0 ? 'box pointer' : 'non-children-box pointer'"  class="folder-name" (click)="checkState(item); item.isOpen = !item.isOpen">
                                            <i [ngClass]="item.isOpen ? 'close-folder' : 'open-folder'"></i>
                                            <span>{{item.name}}</span>
                                        </div> -->
    
                                    </div>
    
                                    <section class="action-btn_list">
        
                                        <ng-template class="btn-list" #popContent>
    
                                            <div class="btn-list_item"
                                            (click)="prepareToCreate(item)" *ngIf="editableStatus && ((categoryType == 'categories' && permissionAccess.check('CATEGORY_CREATE')) || (categoryType == 'files_categories' && permissionAccess.check('FILE_CATEGORY_CREATE')))">
                                                <span>{{ 'Добавить новую категорию' | translate }}</span>
                                            </div>
    
                                            <div class="btn-list_item"
                                            (click)="onEdit(item)" *ngIf="editableStatus && ((categoryType == 'categories' && permissionAccess.check('CATEGORY_EDIT')) || (categoryType == 'files_categories' && permissionAccess.check('FILE_CATEGORY_EDIT')))">
                                                <span>{{ 'EDIT' | translate }}</span>
                                            </div>
    
                                            <div class="list-item_delete"
                                            *ngIf="editableStatus && ((categoryType == 'categories' && permissionAccess.check('CATEGORY_DELETE')) || (categoryType == 'files_categories' && permissionAccess.check('FILE_CATEGORY_DELETE')))"
                                                (click)="deleteOne(item, list)">
                                                <span>{{ 'Удалить' | translate }}</span>
                                            </div>
    
                                        </ng-template>
    
                                        <button type="button" placement="right" container="body" [ngbPopover]="popContent"
                                            [autoClose]="true" triggers="manual" #p="ngbPopover" popoverClass="pop-custom-class"
                                            class="btn btn-none action-btn_active"
                                            (click)="openWindowWithButton(p)"
                                            ngbTooltip="Действия">
                                            <svg-icon class="" src="/assets/images/icons/actions-more.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':18, 'height.px':18}"><i class="bi bi-three-dots-vertical"></i> </svg-icon>
                                            <!-- <i class="bi bi-three-dots-vertical"></i> -->
                                        </button>
    
                                    </section>
    
                                    <!-- <span *ngIf="editableStatus && (permissionAccess.check('CATEGORY_CREATE') || permissionAccess.check('FILE_CATEGORY_CREATE'))"class="text-edit">
                                        <i class="bi bi-plus-circle" (click)="prepareToCreate(item)"></i>
                                    </span>
                                    <span *ngIf="editableStatus && (permissionAccess.check('CATEGORY_EDIT') || permissionAccess.check('FILE_CATEGORY_EDIT'))" class="text-edit">
                                        <i class="bi bi-pencil-square" (click)="onEdit(item)"></i>
                                    </span>
                                    <span *ngIf="editableStatus && (permissionAccess.check('CATEGORY_DELETE') || permissionAccess.check('FILE_CATEGORY_DELETE'))" class="text-edit">
                                        <i class="bi bi-trash" (click)="deleteOne(item, list)"></i>
                                    </span> -->
    
                                    <div class="input-field d-flex">
                                        <div class="form-group input-name-field" *ngIf="item.editable || item.creatable">
                                            <ff-input-lang #element label="{{ 'FILES.NAME_CATEGORIE' | translate }}" fieldId="name" fieldName="name"
                                                fieldType="text" [clearField]="ffInputLangParams.name.clearField"
                                                [required]="ffInputLangParams.name.required" [inputValue]="categoryName"
                                                (changeValue)="eventFnFF('name', $event.name)" (keydown.enter)="onAction(item)">
                                            </ff-input-lang>
                                        </div>
        
                                        <div>
                                            <span *ngIf="!editableStatus && (item.editable || item.creatable)"
                                                class="close-field"><i class="bi bi-x-circle" (click)="closeAction(item)"></i>
                                            </span>        
                                        </div>
                                    </div>
    
    
    
                                </div>
    
                                <ul *ngIf="item.children != null && item.children.length > 0 && item.isOpen">
    
                                    <ng-container *ngTemplateOutlet="Recursion; context:{ list: item.children }">
                                    </ng-container>
    
                                </ul>
    
                            </li>
                        </div>
    
                    </ng-template>

                </div>


            </div>

            <div class="modal-footer btn-box" [ngClass]="{'btn-box_storage': !usageSpace}">
                <div class="storage" *ngIf="usageSpace">
    
                    <div class="storage-header">
            
                        <span>{{ 'STORAGE' | translate }}</span>
            
                        <div class="storage-header_usageSpace" *ngIf="usageSpace">
                            {{usageSpace}} GB
                        </div>
            
                    </div>
                    <div class="storage-progressbar" *ngIf="usageSpace">
                        <ngb-progressbar type="warning" class="warning" [value]="storage"></ngb-progressbar>
                    </div>
        
                </div>
                <!-- <button type="button" class="btn btn-primary btn-sm" (click)="save()">{{ 'SAVE'| translate }}</button> -->
                <button type="button" *ngIf="!settingVue" class="btn btn-light btn-sm" (click)="onClose()">{{ 'CLOSE' | translate }}</button>
            </div>

        </div>

    </div>
</div>